export default [
  {
    title: 'breadcrumb.requestWithdraw',
    route: 'request-withdraw',
    icon: 'TrendingUpIcon',
    resource: 'request-withdrawal',
    action: 'read',
    tag: 0,
  },
]
